import styled from "styled-components";
import ScrollContainer from 'react-indiana-drag-scroll'

export const ColThFixed = styled.th`
  position: sticky;
  left: 0;
  background: var(--color-action-default);
  width: 300px;
  min-width: 300px;  
  z-index: 2;
  height: 50px;
  border-radius: 2px;
`;

export const ColTh = styled.th`  
  background: var(--color-action-default);
  height: 50px;
  border-radius: 2px;    
`;

export const ColTdFixed = styled.td`  
  position: sticky;
  left: 0;
  background: var(--color-contrast-white);
  width: 300px;
  min-width: 300px;
  z-index: 2;
`;

export const StyledTable = styled.table`
  border-spacing: 8px 4px;
  margin-left: -8px;
  border-collapse: separate;

  th:nth-child(n+2):not(:last-child),
  td:nth-child(n+2):not(:last-child) {
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      right: -4px;
      top: 0;
      height: 100%;
      width: 1px;
      opacity: 1;
      background-image: repeating-linear-gradient(
        to bottom,
        var(--color-neutral-400) 0px,
        var(--color-neutral-400) 8px,
        transparent 8px,
        transparent 16px
      );
    }
  }
`;

export const TableScrollContainer = styled(ScrollContainer)`
  display: block;
  overflow-x: auto;
  overflow-y: hidden;

  /* Hide Scrollbar */
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
